$(function() {
  function handleResponse () {
    $(this)
      .on('ajax:success', function (event, data) {
        alert('Успешно!');
      })
      .on('ajax:error', function (event, data) {
        alert(
          'Не удалось осуществить звонок.' +
          'Попробуйте еще раз. Если ошибка повторяется много раз, обратитесь к программистам проекта.'
        );
      });
  }

  $(document)
    .ready(function () {
      $('.btn-recall, .btn-make-call')
        .each(handleResponse);

      $('.on_line__wrapper select').change(function () {
          let current_user_id = $('#current_user_id').val();
          $.ajax({
              url: `/users/${current_user_id}/set_phone_state`,
              data: { state: $(this).val() },
              type: 'PATCH'
          });
      })

    });
});

